import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteDoNotBuyMutationAtom = createMutationAtomFactory(
  'settings.doNotBuyEntryDelete',
  ({ id }: { id: string }) => ({
    complianceDoNotBuyEntryDelete: {
      __args: {
        id,
      },
    },
  }),
);
